import { useState } from 'react';

const WHATSAPP_NUMBER = '919686543847';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
const DEFAULT_MESSAGE = encodeURIComponent('Hi Freshhlock! I have a question...');

export default function FloatingWhatsApp() {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div className="fixed bottom-20 lg:bottom-8 right-4 lg:right-6 z-40 flex flex-col items-end gap-2">
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 ${
          showTooltip
            ? 'opacity-100 translate-y-0 pointer-events-auto'
            : 'opacity-0 translate-y-2 pointer-events-none'
        }`}
      >
        <div className="bg-ink-900 text-paper-50 text-xs font-medium px-3 py-2 rounded-lg shadow-lg whitespace-nowrap">
          Chat with us on WhatsApp
          <div className="absolute right-4 -bottom-1 w-2.5 h-2.5 bg-ink-900 rotate-45"></div>
        </div>
      </div>

      {/* WhatsApp Button */}
      <a
        href={`${WHATSAPP_URL}?text=${DEFAULT_MESSAGE}`}
        target="_blank"
        rel="noopener noreferrer"
        className="relative flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-all duration-300 hover:scale-110 cursor-pointer group"
        style={{ backgroundColor: '#25D366' }}
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        aria-label="Chat on WhatsApp"
      >
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-full animate-ping opacity-25" style={{ backgroundColor: '#25D366' }}></span>
        {/* Icon */}
        <i className="ri-whatsapp-line text-paper-50 text-2xl relative z-10"></i>
      </a>
    </div>
  );
}